export const CommonStyles = {
  buttonStyle: {
    marginTop: "20px",
  },
};
